import { ComparisonDataType } from "./ComparisonTable";

export const comparisonData: Record<string, ComparisonDataType[]> = {
  "en-GB": [
    {
      product: "Superluminous Tinted Skin Glow Serum",
      slugs: [
        "superluminous-skin-glow-serum-fair",
        "superluminous-skin-glow-serum-light",
        "superluminous-skin-glow-serum-light-warm",
        "superluminous-skin-glow-serum-light-medium",
        "superluminous-skin-glow-serum-medium",
        "superluminous-skin-glow-serum-medium-deep",
        "superluminous-skin-glow-serum-deep",
        "superluminous-skin-glow-serum-deep-dark"
      ],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Victoria Beckham Beauty" },
        { name: "Westman Atelier" },
        { name: "Hourglass" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 35,
              currencySymbol: "£"
            },
            "Victoria Beckham Beauty": { price: 104, currencySymbol: "£" },
            "Westman Atelier": { price: 62, currencySymbol: "£" },
            Hourglass: { price: 49, currencySymbol: "£" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 20,
              currencySymbol: "£"
            },
            "Victoria Beckham Beauty": false,
            "Westman Atelier": false,
            Hourglass: false
          }
        },
        {
          name: "Made in Japan",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham Beauty": false,
            "Westman Atelier": false,
            Hourglass: false
          }
        },
        {
          name: "Advanced Peptides",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham Beauty": true,
            "Westman Atelier": false,
            Hourglass: false
          }
        },
        {
          name: "Hyaluronic Acid",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham Beauty": false,
            "Westman Atelier": false,
            Hourglass: true
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham Beauty": false,
            "Westman Atelier": true,
            Hourglass: true
          }
        }
      ]
    },
    {
      product: "Superluminous Under-Eye Genius",
      slugs: [
        "light-medium-superluminous-under-eye-genius",
        "superluminous-under-eye-medium-deep",
        "superluminous-under-eye-deep-caramel",
        "superluminous-under-eye-deep"
      ],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Bobbi Brown" },
        { name: "Charlotte Tilbury" },
        { name: "Smashbox x Becca" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 24,
              currencySymbol: "£"
            },
            "Bobbi Brown": { price: 29, currencySymbol: "£" },
            "Charlotte Tilbury": { price: 28, currencySymbol: "£" },
            "Smashbox x Becca": { price: 25.5, currencySymbol: "£" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 12,
              currencySymbol: "£"
            },
            "Bobbi Brown": false,
            "Charlotte Tilbury": false,
            "Smashbox x Becca": false
          }
        },
        {
          name: "Made In Italy",
          values: {
            "Beauty Pie": true,
            "Bobbi Brown": false,
            "Charlotte Tilbury": true,
            "Smashbox x Becca": false
          }
        },
        {
          name: "Brightening Pigments",
          values: {
            "Beauty Pie": true,
            "Bobbi Brown": true,
            "Charlotte Tilbury": true,
            "Smashbox x Becca": true
          }
        },
        {
          name: "Hydration-Boosters",
          values: {
            "Beauty Pie": true,
            "Bobbi Brown": true,
            "Charlotte Tilbury": true,
            "Smashbox x Becca": true
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Bobbi Brown": true,
            "Charlotte Tilbury": true,
            "Smashbox x Becca": true
          }
        }
      ]
    },
    {
      product: "Wondercolour Longwear Cream Eyeshadow Sticks",
      slugs: [
        "wondercolour-creamshadow-stick-crema-fresca",
        "wondercolour-creamshadow-stick-earthed",
        "wondercolour-creamshadow-stick-miracoli",
        "wondercolour-creamshadow-stick-umber-one",
        "wondercolour-creamshadow-stick-arabica",
        "wondercolour-creamshadow-stick-little-star",
        "wondercolour-creamshadow-stick-brazillionaire",
        "wondercolour-creamshadow-stick-wild-violet",
        "teddy-bare-wondercolour-eyeshadow-stick",
        "beige-bombshell-wondercolour-shadow-stick",
        "wondercolour-longwear-shadow-stick-en-taupe",
        "wondercolour-shadow-stick-vanilla-whirl",
        "wondercolour-cream-shadow-stick-huntress",
        "wondercolour-creamshadow-stick-tea-rose",
        "wondercolour-creamshadow-stick-smoky-garnet",
        "wondercolour-creamshadow-stick-faded-pink"
      ],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Chanel" },
        { name: "Bobbi Brown" },
        { name: "Victoria Beckham" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 20,
              currencySymbol: "£"
            },
            Chanel: { price: 35, currencySymbol: "£" },
            "Bobbi Brown": { price: 29.5, currencySymbol: "£" },
            "Victoria Beckham": { price: 32, currencySymbol: "£" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 12,
              currencySymbol: "£"
            },
            Chanel: false,
            "Bobbi Brown": false,
            "Victoria Beckham": false
          }
        },
        {
          name: "Made In Italy",
          values: {
            "Beauty Pie": true,
            Chanel: true,
            "Bobbi Brown": true,
            "Victoria Beckham": true
          }
        },
        {
          name: "Longwear Formula",
          values: {
            "Beauty Pie": true,
            Chanel: true,
            "Bobbi Brown": true,
            "Victoria Beckham": true
          }
        },
        {
          name: "Triple-Wax Blend For A Smooth, Even Finish",
          values: {
            "Beauty Pie": true,
            Chanel: true,
            "Bobbi Brown": true,
            "Victoria Beckham": true
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            Chanel: true,
            "Bobbi Brown": true,
            "Victoria Beckham": true
          }
        }
      ]
    },
    {
      product: "Wrap Star Tubing Mascara",
      slugs: ["wrap-star-tubing-mascara", "wrap-star-tubing-mascara-brown"],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Victoria Beckham" },
        { name: "Hourglass" },
        { name: "Milk Makeup" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 17,
              currencySymbol: "£"
            },
            "Victoria Beckham": { price: 32, currencySymbol: "£" },
            Hourglass: { price: 32, currencySymbol: "£" },
            "Milk Makeup": { price: 26, currencySymbol: "£" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 10,
              currencySymbol: "£"
            },
            "Victoria Beckham": false,
            Hourglass: false,
            "Milk Makeup": false
          }
        },
        {
          name: "Made In Korea",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham": false,
            Hourglass: false,
            "Milk Makeup": false
          }
        },
        {
          name: "Tubing Technology",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham": true,
            Hourglass: true,
            "Milk Makeup": true
          }
        },
        {
          name: "Lash-Strengthening Peptide Complex",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham": true,
            Hourglass: false,
            "Milk Makeup": false
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham": true,
            Hourglass: true,
            "Milk Makeup": false
          }
        }
      ]
    },
    {
      product: "Wondergloss Collagen Lip Oil",
      slugs: [
        "wondergloss-collagen-lip-spicy-pink",
        "wondergloss-lip-oil-nude-nectar",
        "wondergloss-lip-oil-plum-naked",
        "wondergloss-collagen-lip-oil-cherry-o"
      ],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Yves Saint Laurent" },
        { name: "Guerlain" },
        { name: "Dior" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 20,
              currencySymbol: "£"
            },
            "Yves Saint Laurent": { price: 38, currencySymbol: "£" },
            Guerlain: { price: 35, currencySymbol: "£" },
            Dior: { price: 33, currencySymbol: "£" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 12,
              currencySymbol: "£"
            },
            "Yves Saint Laurent": false,
            Guerlain: false,
            Dior: false
          }
        },
        {
          name: "Made In Italy",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": false,
            Guerlain: false,
            Dior: false
          }
        },
        {
          name: "Peptides & Collagen Actives",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": false,
            Guerlain: false,
            Dior: false
          }
        },
        {
          name: "7+ Natural Oils",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": false,
            Guerlain: true,
            Dior: false
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": true,
            Guerlain: true,
            Dior: true
          }
        }
      ]
    },
    {
      product: "Unlipstick Modern Matte Lip Tint",
      slugs: [
        "unlipstick-lip-tint-unsurpassed",
        "unlipstick-lip-tint-undeniable",
        "unlipstick-lip-tint-unrivaled",
        "unlipstick-lip-tint-unforgettable",
        "unlipstick-lip-tint-unphased",
        "unlipstick-lip-tint-unauthorized",
        "unlipstick-lip-tint-undisclosed",
        "unlipstick-lip-tint-unmatched"
      ],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Yves Saint Laurent" },
        { name: "Givenchy" },
        { name: "Violette" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 20,
              currencySymbol: "£"
            },
            "Yves Saint Laurent": { price: 38, currencySymbol: "£" },
            Givenchy: { price: 37, currencySymbol: "£" },
            Violette: { price: 30, currencySymbol: "£" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 12,
              currencySymbol: "£"
            },
            "Yves Saint Laurent": false,
            Givenchy: false,
            Violette: false
          }
        },
        {
          name: "Made In Korea",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": false,
            Givenchy: false,
            Violette: false
          }
        },
        {
          name: "Hydrating Hyaluronic Acid",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": false,
            Givenchy: false,
            Violette: false
          }
        },
        {
          name: "Barrier-Supporting Squalane",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": false,
            Givenchy: false,
            Violette: false
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": true,
            Givenchy: true,
            Violette: false
          }
        }
      ]
    },
    {
      product: "Youthbomb 360 Radiance Concentrate",
      slugs: ["youthbomb-radiance-concentrate-serum"],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Augustinus Bader" },
        { name: "Dr Barbara Sturm" },
        { name: "Dr Sebagh" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 75,
              currencySymbol: "£"
            },
            "Augustinus Bader": { price: 290, currencySymbol: "£" },
            "Dr Barbara Sturm": { price: 290, currencySymbol: "£" },
            "Dr Sebagh": { price: 112.5, currencySymbol: "£" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 44,
              currencySymbol: "£"
            },
            "Augustinus Bader": false,
            "Dr Barbara Sturm": false,
            "Dr Sebagh": false
          }
        },
        {
          name: "Made In Switzerland",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": false,
            "Dr Barbara Sturm": false,
            "Dr Sebagh": false
          }
        },
        {
          name: "Anti-Ageing Peptides",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": true,
            "Dr Barbara Sturm": false,
            "Dr Sebagh": true
          }
        },
        {
          name: "Deep Hydration: Polyglutamic Acid",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": false,
            "Dr Barbara Sturm": false,
            "Dr Sebagh": false
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": false,
            "Dr Barbara Sturm": false,
            "Dr Sebagh": false
          }
        }
      ]
    },
    {
      product: "Youthbomb Extreme Retinal Triple Renewal Serum",
      slugs: ["youthbomb-retinal-renewal-serum"],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Augustinus Bader" },
        { name: "Omorovicza" },
        { name: "Medik8" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 82,
              currencySymbol: "£"
            },
            "Augustinus Bader": { price: 290, currencySymbol: "£" },
            Omorovicza: { price: 150, currencySymbol: "£" },
            Medik8: { price: 109, currencySymbol: "£" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 49,
              currencySymbol: "£"
            },
            "Augustinus Bader": false,
            Omorovicza: false,
            Medik8: false
          }
        },
        {
          name: "Made In Switzerland",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": false,
            Omorovicza: false,
            Medik8: false
          }
        },
        {
          name: "Triple Retinoid Complex",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": false,
            Omorovicza: false,
            Medik8: false
          }
        },
        {
          name: "Brightening & Skin Turnover Actives",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": true,
            Omorovicza: true,
            Medik8: true
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": false,
            Omorovicza: false,
            Medik8: true
          }
        }
      ]
    },
    {
      product: "Triple Hyaluronic Acid & Lipopeptide Serum",
      slugs: ["triple-hyaluronic-acid-serum"],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Skinceuticals" },
        { name: "111Skin" },
        { name: "Medik8" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 40,
              currencySymbol: "£"
            },
            Skinceuticals: { price: 120, currencySymbol: "£" },
            "111Skin": { price: 100, currencySymbol: "£" },
            Medik8: { price: 45, currencySymbol: "£" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 24,
              currencySymbol: "£"
            },
            Skinceuticals: false,
            "111Skin": false,
            Medik8: false
          }
        },
        {
          name: "Made In Switzerland",
          values: {
            "Beauty Pie": true,
            Skinceuticals: false,
            "111Skin": false,
            Medik8: false
          }
        },
        {
          name: "Multiple Weights Of Hyaluronic Acid",
          values: {
            "Beauty Pie": true,
            Skinceuticals: true,
            "111Skin": false,
            Medik8: false
          }
        },
        {
          name: "Anti-Ageing Peptides",
          values: {
            "Beauty Pie": true,
            Skinceuticals: false,
            "111Skin": false,
            Medik8: false
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            Skinceuticals: true,
            "111Skin": true,
            Medik8: true
          }
        }
      ]
    },
    {
      product: "Über Youth Neck & Chest Super-Lift Serum Spray",
      slugs: ["uber-youth-neck-and-chest-serum-spray"],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Dr Barbara Sturm" },
        { name: "Sarah Chapman" },
        { name: "Trinny London" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 38,
              currencySymbol: "£"
            },
            "Dr Barbara Sturm": { price: 220, currencySymbol: "£" },
            "Sarah Chapman": { price: 69, currencySymbol: "£" },
            "Trinny London": { price: 68, currencySymbol: "£" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 17.5,
              currencySymbol: "£"
            },
            "Dr Barbara Sturm": false,
            "Sarah Chapman": false,
            "Trinny London": false
          }
        },
        {
          name: "Made In Switzerland",
          values: {
            "Beauty Pie": true,
            "Dr Barbara Sturm": false,
            "Sarah Chapman": false,
            "Trinny London": false
          }
        },
        {
          name: "Firming & Anti-wrinkle Peptides",
          values: {
            "Beauty Pie": true,
            "Dr Barbara Sturm": true,
            "Sarah Chapman": true,
            "Trinny London": true
          }
        },
        {
          name: "Brightening Niacinamide",
          values: {
            "Beauty Pie": true,
            "Dr Barbara Sturm": false,
            "Sarah Chapman": true,
            "Trinny London": false
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Dr Barbara Sturm": false,
            "Sarah Chapman": false,
            "Trinny London": true
          }
        }
      ]
    },
    {
      product: "C-Wave Light Facial LED Mask",
      slugs: ["led-light-facial-mask"],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "The Light Salon" },
        { name: "Omnilux" },
        { name: "Current Body - Series 1" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 200,
              currencySymbol: "£"
            },
            "The Light Salon": { price: 395, currencySymbol: "£" },
            Omnilux: { price: 348, currencySymbol: "£" },
            "Current Body - Series 1": { price: 299.99, currencySymbol: "£" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 120,
              currencySymbol: "£"
            },
            "The Light Salon": false,
            Omnilux: false,
            "Current Body - Series 1": false
          }
        },
        {
          name: "630–633nm Red Light + 830nm Near-Infrared Light",
          values: {
            "Beauty Pie": true,
            "The Light Salon": true,
            Omnilux: true,
            "Current Body - Series 1": true
          }
        },
        {
          name: "Free Shipping",
          values: {
            "Beauty Pie": true,
            "The Light Salon": true,
            Omnilux: true,
            "Current Body - Series 1": true
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "The Light Salon": false,
            Omnilux: false,
            "Current Body - Series 1": false
          }
        }
      ]
    },
    {
      product: "The Dynamo Deep LED Collagen-Boosting Mask",
      slugs: [],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Mz Skin" },
        { name: "Current Body - Series 2" },
        { name: "Lumalux Face" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 275,
              currencySymbol: "£"
            },
            "Mz Skin": { price: 750, currencySymbol: "£" },
            "Current Body - Series 2": { price: 399.99, currencySymbol: "£" },
            "Lumalux Face": { price: 309, currencySymbol: "£" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 199,
              currencySymbol: "£"
            },
            "Victoria Beckham Beauty": false,
            "Westman Atelier": false,
            Hourglass: false
          }
        },
        {
          name: "630–633nm Red Light + 830-850nm Near-Infrared Light",
          values: {
            "Beauty Pie": true,
            "Mz Skin": true,
            "Current Body - Series 2": true,
            "Lumalux Face": true
          }
        },
        {
          name: "Deep-Infrared: 1070 - 1072nm",
          values: {
            "Beauty Pie": true,
            "Mz Skin": false,
            "Current Body - Series 2": true,
            "Lumalux Face": true
          }
        },
        {
          name: "Free Shipping",
          values: {
            "Beauty Pie": true,
            "Mz Skin": true,
            "Current Body - Series 2": true,
            "Lumalux Face": true
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Mz Skin": false,
            "Current Body - Series 2": false,
            "Lumalux Face": false
          }
        }
      ]
    }
  ],
  "en-US": [
    {
      product: "Superluminous Tinted Skin Glow Serum",
      slugs: [
        "superluminous-skin-glow-serum-light-warm",
        "superluminous-skin-glow-serum-fair",
        "superluminous-skin-glow-serum-light",
        "superluminous-skin-glow-serum-light",
        "superluminous-skin-glow-serum-medium",
        "superluminous-skin-glow-serum-medium-deep",
        "superluminous-skin-glow-serum-deep",
        "superluminous-skin-glow-serum-deep-dark"
      ],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Victoria Beckham" },
        { name: "Westman Atelier" },
        { name: "Hourglass" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 42,
              currencySymbol: "$"
            },
            "Victoria Beckham": { price: 110, currencySymbol: "$" },
            "Westman Atelier": { price: 68, currencySymbol: "$" },
            Hourglass: { price: 49, currencySymbol: "$" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 25,
              currencySymbol: "$"
            },
            "Victoria Beckham": false,
            "Westman Atelier": false,
            Hourglass: false
          }
        },
        {
          name: "Made in Japan",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham": false,
            "Westman Atelier": false,
            Hourglass: false
          }
        },
        {
          name: "Advanced Peptides",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham": true,
            "Westman Atelier": false,
            Hourglass: false
          }
        },
        {
          name: "Hyaluronic Acid",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham": false,
            "Westman Atelier": false,
            Hourglass: true
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham": false,
            "Westman Atelier": true,
            Hourglass: true
          }
        }
      ]
    },
    {
      product: "Superluminous Undereye Genius",
      slugs: [
        "superluminous-under-eye-genius-light-medium",
        "superluminous-under-eye-medium-deep",
        "superluminous-under-eye-deep-caramel",
        "superluminous-under-eye-deep"
      ],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Bobbi Brown" },
        { name: "Charlotte Tilbury" },
        { name: "Smashbox x Becca" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 28,
              currencySymbol: "$"
            },
            "Bobbi Brown": { price: 35, currencySymbol: "$" },
            "Charlotte Tilbury": { price: 32, currencySymbol: "$" },
            "Smashbox x Becca": { price: 33, currencySymbol: "$" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 14,
              currencySymbol: "$"
            },
            "Bobbi Brown": false,
            "Charlotte Tilbury": false,
            "Smashbox x Becca": false
          }
        },
        {
          name: "Made In Italy",
          values: {
            "Beauty Pie": true,
            "Bobbi Brown": false,
            "Charlotte Tilbury": true,
            "Smashbox x Becca": false
          }
        },
        {
          name: "Brightening Pigments",
          values: {
            "Beauty Pie": true,
            "Bobbi Brown": true,
            "Charlotte Tilbury": true,
            "Smashbox x Becca": true
          }
        },
        {
          name: "Hydration-Boosters",
          values: {
            "Beauty Pie": true,
            "Bobbi Brown": true,
            "Charlotte Tilbury": true,
            "Smashbox x Becca": true
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Bobbi Brown": true,
            "Charlotte Tilbury": true,
            "Smashbox x Becca": true
          }
        }
      ]
    },
    {
      product: "Wondercolour Longwear Cream Eyeshadow Sticks",
      slugs: [
        "wondercolour-creamshadow-stick-crema-fresca",
        "wondercolour-creamshadow-stick-earthed",
        "wondercolour-creamshadow-stick-miracoli",
        "wondercolour-creamshadow-stick-umber-one",
        "wondercolour-creamshadow-stick-arabica",
        "wondercolour-creamshadow-stick-little-star",
        "wondercolour-creamshadow-stick-brazillionaire",
        "wondercolour-creamshadow-stick-wild-violet",
        "teddy-bare-wondercolour-eyeshadow-stick",
        "beige-bombshell-wondercolour-shadow-stick",
        "wondercolour-longwear-shadow-stick-en-taupe",
        "wondercolour-shadow-stick-vanilla-whirl",
        "wondercolour-cream-shadow-stick-huntress",
        "wondercolour-creamshadow-stick-tea-rose",
        "wondercolour-creamshadow-stick-smoky-garnet",
        "wondercolour-creamshadow-stick-faded-pink"
      ],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Chanel" },
        { name: "Bobbi Brown" },
        { name: "Victoria Beckham" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 25,
              currencySymbol: "$"
            },
            Chanel: { price: 40, currencySymbol: "$" },
            "Bobbi Brown": { price: 34, currencySymbol: "$" },
            "Victoria Beckham": { price: 34, currencySymbol: "$" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 14,
              currencySymbol: "$"
            },
            Chanel: false,
            "Bobbi Brown": false,
            "Victoria Beckham": false
          }
        },
        {
          name: "Made In Italy",
          values: {
            "Beauty Pie": true,
            Chanel: true,
            "Bobbi Brown": true,
            "Victoria Beckham": true
          }
        },
        {
          name: "Longwear Formula",
          values: {
            "Beauty Pie": true,
            Chanel: true,
            "Bobbi Brown": true,
            "Victoria Beckham": true
          }
        },
        {
          name: "Triple-Wax Blend For A Smooth, Even Finish",
          values: {
            "Beauty Pie": true,
            Chanel: true,
            "Bobbi Brown": true,
            "Victoria Beckham": true
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            Chanel: true,
            "Bobbi Brown": true,
            "Victoria Beckham": true
          }
        }
      ]
    },
    {
      product: "Wrap Star Tubing Mascara",
      slugs: ["wrap-star-tubing-mascara", "wrap-star-tubing-mascara-brown"],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Victoria Beckham" },
        { name: "Hourglass" },
        { name: "Milk Makeup" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 22,
              currencySymbol: "$"
            },
            "Victoria Beckham": { price: 34, currencySymbol: "$" },
            Hourglass: { price: 33, currencySymbol: "$" },
            "Milk Makeup": { price: 29, currencySymbol: "$" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 13,
              currencySymbol: "$"
            },
            "Victoria Beckham": false,
            Hourglass: false,
            "Milk Makeup": false
          }
        },
        {
          name: "Made In Korea",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham": false,
            Hourglass: false,
            "Milk Makeup": false
          }
        },
        {
          name: "Tubing Technology",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham": true,
            Hourglass: true,
            "Milk Makeup": true
          }
        },
        {
          name: "Lash-Strengthening Peptide Complex",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham": true,
            Hourglass: false,
            "Milk Makeup": false
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Victoria Beckham": true,
            Hourglass: true,
            "Milk Makeup": true
          }
        }
      ]
    },
    {
      product: "Wondergloss Collagen Lip Oil",
      slugs: [
        "wondergloss-collagen-lip-spicy-pink",
        "wondergloss-lip-oil-nude-nectar",
        "wondergloss-lip-oil-plum-naked",
        "wondergloss-collagen-lip-oil-cherry-o"
      ],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Yves Saint Laurent" },
        { name: "Guerlain" },
        { name: "Dior" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 25,
              currencySymbol: "$"
            },
            "Yves Saint Laurent": { price: 40, currencySymbol: "$" },
            Guerlain: { price: 40, currencySymbol: "$" },
            Dior: { price: 40, currencySymbol: "$" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 14,
              currencySymbol: "$"
            },
            "Yves Saint Laurent": false,
            Guerlain: false,
            Dior: false
          }
        },
        {
          name: "Made In Italy",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": false,
            Guerlain: false,
            Dior: false
          }
        },
        {
          name: "Peptides & Collagen Actives",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": false,
            Guerlain: false,
            Dior: false
          }
        },
        {
          name: "7+ Natural Oils",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": false,
            Guerlain: true,
            Dior: false
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": true,
            Guerlain: false,
            Dior: true
          }
        }
      ]
    },
    {
      product: "Unlipstick Modern Matte Lip Tint",
      slugs: [
        "unlipstick-lip-tint-unsurpassed",
        "unlipstick-lip-tint-undeniable",
        "unlipstick-lip-tint-unrivaled",
        "unlipstick-lip-tint-unforgettable",
        "unlipstick-lip-tint-unphased",
        "unlipstick-lip-tint-unauthorized",
        "unlipstick-lip-tint-undisclosed",
        "unlipstick-lip-tint-unmatched"
      ],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Yves Saint Laurent" },
        { name: "Givenchy" },
        { name: "Violette" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 25,
              currencySymbol: "$"
            },
            "Yves Saint Laurent": { price: 48, currencySymbol: "$" },
            Givenchy: { price: 48, currencySymbol: "$" },
            Violette: { price: 29, currencySymbol: "$" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 15,
              currencySymbol: "$"
            },
            "Yves Saint Laurent": false,
            Givenchy: false,
            Violette: false
          }
        },
        {
          name: "Made In Korea",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": false,
            Givenchy: false,
            Violette: false
          }
        },
        {
          name: "Hydrating Hyaluronic Acid",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": false,
            Givenchy: false,
            Violette: false
          }
        },
        {
          name: "Barrier-Supporting Squalane",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": false,
            Givenchy: false,
            Violette: false
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Yves Saint Laurent": true,
            Givenchy: true,
            Violette: false
          }
        }
      ]
    },
    {
      product: "Youthbomb 360 Radiance Concentrate",
      slugs: ["youthbomb-radiance-concentrate-serum"],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Augustinus Bader" },
        { name: "Dr Barbara Sturm" },
        { name: "Dr Sebagh" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 82,
              currencySymbol: "$"
            },
            "Augustinus Bader": { price: 405, currencySymbol: "$" },
            "Dr Barbara Sturm": { price: 380, currencySymbol: "$" },
            "Dr Sebagh": { price: 180, currencySymbol: "$" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 49,
              currencySymbol: "$"
            },
            "Augustinus Bader": false,
            "Dr Barbara Sturm": false,
            "Dr Sebagh": false
          }
        },
        {
          name: "Made In Switzerland",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": false,
            "Dr Barbara Sturm": false,
            "Dr Sebagh": false
          }
        },
        {
          name: "Anti-Aging Peptides",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": true,
            "Dr Barbara Sturm": false,
            "Dr Sebagh": true
          }
        },
        {
          name: "Deep Hydration: Polyglutamic Acid",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": false,
            "Dr Barbara Sturm": false,
            "Dr Sebagh": false
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": false,
            "Dr Barbara Sturm": false,
            "Dr Sebagh": false
          }
        }
      ]
    },
    {
      product: "Youthbomb Extreme Triple Retinal Renewal Serum",
      slugs: ["youthbomb-retinal-renewal-serum"],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Augustinus Bader" },
        { name: "Omorovicza" },
        { name: "Medik8" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 99,
              currencySymbol: "$"
            },
            "Augustinus Bader": { price: 380, currencySymbol: "$" },
            Omorovicza: { price: 200, currencySymbol: "$" },
            Medik8: { price: 135, currencySymbol: "$" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 59,
              currencySymbol: "$"
            },
            "Augustinus Bader": false,
            Omorovicza: false,
            Medik8: false
          }
        },
        {
          name: "Made In Switzerland",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": false,
            Omorovicza: false,
            Medik8: false
          }
        },
        {
          name: "Triple Retinoid Complex",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": false,
            Omorovicza: false,
            Medik8: false
          }
        },
        {
          name: "Brightening & Skin Turnover Actives",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": true,
            Omorovicza: true,
            Medik8: true
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Augustinus Bader": false,
            Omorovicza: false,
            Medik8: true
          }
        }
      ]
    },
    {
      product: "Triple Hyaluronic Acid Serum",
      slugs: ["triple-hyaluronic-acid-serum"],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Skinceuticals" },
        { name: "111Skin" },
        { name: "Medik8" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 49,
              currencySymbol: "$"
            },
            Skinceuticals: { price: 120, currencySymbol: "$" },
            "111Skin": { price: 135, currencySymbol: "$" },
            Medik8: { price: 54, currencySymbol: "$" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 29,
              currencySymbol: "$"
            },
            Skinceuticals: false,
            "111Skin": false,
            Medik8: false
          }
        },
        {
          name: "Made In Switzerland",
          values: {
            "Beauty Pie": true,
            Skinceuticals: false,
            "111Skin": false,
            Medik8: false
          }
        },
        {
          name: "Multiple Weights Of Hyaluronic Acid",
          values: {
            "Beauty Pie": true,
            Skinceuticals: true,
            "111Skin": false,
            Medik8: false
          }
        },
        {
          name: "Anti-Aging Peptides",
          values: {
            "Beauty Pie": true,
            Skinceuticals: false,
            "111Skin": false,
            Medik8: false
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            Skinceuticals: true,
            "111Skin": true,
            Medik8: true
          }
        }
      ]
    },
    {
      product: "Über Youth Neck & Chest Super-Lift Serum Spray",
      slugs: ["uber-youth-neck-and-chest-serum-spray"],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Dr Barbara Sturm" },
        { name: "Sarah Chapman" },
        { name: "Trinny London" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 42,
              currencySymbol: "$"
            },
            "Dr Barbara Sturm": { price: 255, currencySymbol: "$" },
            "Sarah Chapman": { price: 96, currencySymbol: "$" },
            "Trinny London": { price: 88, currencySymbol: "$" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 22,
              currencySymbol: "$"
            },
            "Dr Barbara Sturm": false,
            "Sarah Chapman": false,
            "Trinny London": false
          }
        },
        {
          name: "Made In Switzerland",
          values: {
            "Beauty Pie": true,
            "Dr Barbara Sturm": false,
            "Sarah Chapman": false,
            "Trinny London": false
          }
        },
        {
          name: "Firming & Anti-wrinkle Peptides",
          values: {
            "Beauty Pie": true,
            "Dr Barbara Sturm": true,
            "Sarah Chapman": true,
            "Trinny London": true
          }
        },
        {
          name: "Brightening Niacinamide",
          values: {
            "Beauty Pie": true,
            "Dr Barbara Sturm": false,
            "Sarah Chapman": true,
            "Trinny London": false
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Dr Barbara Sturm": false,
            "Sarah Chapman": false,
            "Trinny London": true
          }
        }
      ]
    },
    {
      product: "C-Wave Light Facial LED Mask",
      slugs: ["led-light-facial-mask"],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "The Light Salon" },
        { name: "Omnilux" },
        { name: "Current Body - Series 1" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 235,
              currencySymbol: "$"
            },
            "The Light Salon": { price: 495, currencySymbol: "$" },
            Omnilux: { price: 395, currencySymbol: "$" },
            "Current Body - Series 1": { price: 379.99, currencySymbol: "$" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 140,
              currencySymbol: "$"
            },
            "The Light Salon": false,
            Omnilux: false,
            "Current Body - Series 1": false
          }
        },
        {
          name: "630–633nm Red Light + 830nm Near-Infrared Light",
          values: {
            "Beauty Pie": true,
            "The Light Salon": true,
            Omnilux: true,
            "Current Body - Series 1": true
          }
        },
        {
          name: "Free Shipping",
          values: {
            "Beauty Pie": true,
            "The Light Salon": true,
            Omnilux: true,
            "Current Body - Series 1": true
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "The Light Salon": false,
            Omnilux: false,
            "Current Body - Series 1": false
          }
        }
      ]
    },
    {
      product: "The Dynamo Deep LED Collagen-Boosting Mask",
      slugs: [],
      columns: [
        { name: "Beauty Pie", highlighted: true },
        { name: "Mz Skin" },
        { name: "Current Body - Series 2" },
        { name: "Lumalux Face" }
      ],
      features: [
        {
          name: "Price",
          values: {
            "Beauty Pie": {
              price: 299,
              currencySymbol: "$"
            },
            "Mz Skin": { price: 750, currencySymbol: "$" },
            "Current Body - Series 2": { price: 469.99, currencySymbol: "$" },
            "Lumalux Face": { price: 369, currencySymbol: "$" }
          }
        },
        {
          name: "Exclusive Member Price",
          values: {
            "Beauty Pie": {
              price: 238,
              currencySymbol: "$"
            },
            "Mz Skin": false,
            "Current Body - Series 2": false,
            "Lumalux Face": false
          }
        },
        {
          name: "630–633nm Red Light + 830-850nm Near-Infrared Light",
          values: {
            "Beauty Pie": true,
            "Mz Skin": true,
            "Current Body - Series 2": true,
            "Lumalux Face": true
          }
        },
        {
          name: "Deep-Infrared: 1070 - 1072nm",
          values: {
            "Beauty Pie": true,
            "Mz Skin": false,
            "Current Body - Series 2": true,
            "Lumalux Face": true
          }
        },
        {
          name: "Free Shipping",
          values: {
            "Beauty Pie": true,
            "Mz Skin": true,
            "Current Body - Series 2": true,
            "Lumalux Face": true
          }
        },
        {
          name: "Free Returns",
          values: {
            "Beauty Pie": true,
            "Mz Skin": false,
            "Current Body - Series 2": false,
            "Lumalux Face": false
          }
        }
      ]
    }
  ]
};
